export default __webpack_public_path__ + "static/media/protest.d46ba735.jpeg";